import { useHead } from "../services/common";

import { Link } from "../components/Language";
import Carousel from "../components/Carousel";
import Footer from "../components/Footer";


export default function NotFound() {
    useHead(
        "404 stránka nenalezena",
        "404 stránka nenalezena | Jilemnicko - společenství obcí"
    );

    return <>
        <Carousel />
        <main>
            <section className="content-page" style={{ textAlign: "center" }}>
                <h1>404 - stránka nenalezena</h1>
                <p><Link to="/">Přejít na domovskou stránku</Link></p>
            </section>
        </main>
        <Footer />
    </>;
}
